export default "__VITE_ASSET__DBzm7waI__"